module.exports = __webpack_public_path__ + "img/audiospeek.44a4823b.gif";